module.exports = __webpack_public_path__ + "static/media/IMG-4.df9d8dc2.jpg";